import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
 * **Fastbooking**
 *
 * @exports bs_53
 * @category engines
 */
function factory({ window, document, thn }) {

  const engine = {};
  const isLindenbergHotels = thn.data.accountUserId === 1045641;

  /**
     * @memberOf module:bs_53
     * @see {@link allowed_location}
     *
     * @param {object} ctx - The context object.
     */
  engine.allowedLocation = function allowedLocation() {

    let isAllowedLocation = true;

    // For Centara Grand Mirage Beach Resort Pattaya
    // in the Fastbooking engine
    // only allow execution if the property is "cnpat17217", as expected
    // Reason: this script is inserted for other properties in the wild
    // https://thehotelsnetwork.atlassian.net/browse/CS-3380
    if (thn.data.propertyId === 1013184
      && window.location.hostname === 'www.book-secure.com'
      && thn.parseUrlParameter('property') !== 'cnpat17217'
    ) {
      isAllowedLocation = false;
    }

    return isAllowedLocation;
  };

  /**
     * @memberOf module:bs_53
     * @see {@link language_check}
     *
     * @param {object} ctx - The context object.
     */
  engine.languageCheck = function languageCheck(ctx) {

    return new Promise(function (resolve, reject) {

      let lang;
      const $ = window.jQuery;

      function normalize(str) {
        if (str === 'cn') {
          return 'zh';
        }
        return str;
      }

      thn.domReady().then(function () {

        lang = thn.data.propertyId === 1013102 // Le Vignon Paris
          && $ && $('[data-navigation-container-id="body"][data-navigation-content-id]').attr('data-navigation-content-id');
        lang = lang && normalize(lang);
        if (lang && ctx.langs.test(lang)) {
          resolve(lang);
          return;
        }

        if (thn.data.accountUserId === 1047130) { // Yulan Group
          resolve(document.documentElement.lang);
          return;
        }

        if (thn.data.accountUserId === 1047171) { // The Royal Garden
          resolve(thn.parseUrlParameter('locale') || window.location.pathname?.split('/')?.[1]);
          return;
        }

        lang = window.location.pathname.match(ctx.urlRe);
        lang = lang && lang.length && lang[1].toLowerCase();
        lang = lang && normalize(lang);
        if (lang && ctx.langs.test(lang)) {
          resolve(lang);
          return;
        }

        if (thn.data.propertyId === 1011792) { // Hotel Fontanellas
          resolve('es');
          return;
        }

        if (thn.data.accountUserId === 1037736 && window.location.hostname.match(/caramell/)) { // Hotel Caramell
          // When we visit the page, the language that appears disappears from the list of languages.
          // If this lang class does not appear in the html is because we are seeing that language
          const el = document.querySelector('[class^=s_]');
          const currentClass = el?.className || '';
          const langMap = [
            ['en', 's_en'],
            ['de', 's_de'],
            ['ru', 's_ru'],
            ['sk', 's_sk'],
          ];

          lang = langMap.find(([, cls]) => !currentClass.includes(cls))?.[0] || 'hu';
          resolve(lang);
          return;
        }

        lang = thn.parseUrlParameter('locale').substr(0, 2);
        lang = lang && normalize(lang);
        if (lang && ctx.langs.test(lang)) {
          resolve(lang);
          return;
        }

        lang = window._locales && $ && $('#fb-headbar-block-language .fb-headbar-value');
        lang = lang && lang.length && lang.text();
        lang = lang && normalize(lang);
        if (lang) {
          lang = Object.keys(window._locales).filter(function (key) {
            return window._locales[key] === lang;
          });
          lang = lang.length && lang[0].substr(0, 2);
          lang = lang && normalize(lang);
          if (lang && ctx.langs.test(lang)) {
            resolve(lang);
            return;
          }
        }

        lang = window.icl_vars && window.icl_vars.current_language;
        if (lang && ctx.langs.test(lang)) {
          resolve(lang);
          return;
        }
        // User_id : 1033804
        const elements = document.querySelectorAll('img.fade');
        if (window.location.hostname === 'www.turim-hotels.com' && elements) {
          const langs = ['pt', 'es', 'en'];

          lang = langs.find((langCode, index) => elements[index]?.style?.opacity) || lang;
        }
        if (thn.data.accountUserId === 1036799) {
          lang = thn.parseUrlParameter('setlang');

          if (lang && ctx.langs.test(lang)) {
            resolve(lang);
            return;
          }
        }

        // Continental Hotels
        if (thn.data.accountUserId === 1032579 && window.location.hostname.match(/continental/)) {
          lang = window && window.mejsL10n && window.mejsL10n.language;
          if (lang && ctx.langs.test(lang)) {
            resolve(lang);
            return;
          }
        }

        // https://www.charlottehaven.com/dk/da/
        if (thn.data.propertyId === 1031785 && window.location.hostname.match(/charlottehaven/)) {
          const isActiveEl = document.querySelector('.header__language .is-active');
          lang = isActiveEl?.textContent?.match(/[A-Za-z]{2}/)[0].toLowerCase();
          if (lang && ctx.langs.test(lang)) {
            resolve(lang);
            return;
          }
        }

        reject('no_language');
      });
    });
  };

  /**
     * @memberOf module:bs_53
     * @see {@link generate_search_url}
     *
     * @param {object} ctx - The context object.
     */
  engine.generateSearchUrl = function generateSearchUrl(ctx) {
    const url = new URL(ctx.baseUrl);
    const validUrl = url.host.match(/book-secure/);

    if (validUrl) {
      // https://www.book-secure.com/index.php?s=results&property=mylan25239&arrival=2022-07-20&departure=2022-07-21&code=HVL05&adults1=1&children1=0&locale=en_GB&currency=MYR&stid=n5fpel33r
      url.searchParams.set('arrival', '[date_begin]');
      url.searchParams.set('departure', '[date_end]');
      url.searchParams.set('adults1', '[adults]');
      url.searchParams.set('children1', '[children]');
      url.searchParams.set('locale', '[language]');
      url.searchParams.set('currency', '[currency]');
      url.searchParams.set('code', '');
      url.searchParams.set('stid', '');

      // export into ctx.new_url
      ctx.newUrl = url.toString();

      ctx.newData.dateBegin = (ctx.newData?.dateBegin || ctx.data?.dateBegin)?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$1-$2-$3');
      ctx.newData.dateEnd = (ctx.newData?.dateEnd || ctx.data?.dateEnd)?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$1-$2-$3');

    } else {
      // This is not a valid URL
      ctx.newUrl = '';
    }

    return ctx;
  };

  /**
     * @memberOf module:bs_53
     * @see {@link onStateChange}
     *
     * @param {object} ctx - The context object.
     */
  engine.onStateChange = function onStateChange(ctx) {
    thn.debounce(() => thn.pageCheck(), 800)();
    thn.debounce(() => thn.languageCheck(), 800)();
    if (thn.widgets.price.isTargetPage('Rooms and Rates')) {
      thn.debounce(() => thn.widgets.price.update(), 800)();

    }
    if (['Rooms and Rates', 'Packages'].includes(thn.data.pageName)) {
      // restore/refresh PW
      if (isLindenbergHotels) {
        thn.pageCheck({ force: true });
      } else {
        thn.widgets.price.update();
      }
      // if PW not ready, then observe
      if (!thn.widgets.price.isSet()) {
        thn.widgets.price.observeDom();
      }
    }

    // Le Vignon Paris
    if (thn.data.propertyId === 1013102) {
      setTimeout(thn.languageCheck, 0);
    }
  };

  /**
     * @memberOf module:bs_53
     * @see {@link prestart}
     *
     * @param {object} ctx - The context object.
     */
  engine.boot = function boot() {

    const calendarContainer = document.querySelector('#fb-qs-summary-dates');

    if (calendarContainer) {
      let refreshPage = thn.debounce(thn.pageCheck, 800);
      thn.observeDom(calendarContainer, refreshPage, {
        attributes: true,
      });

      thn.shutdown(() => {
        refreshPage.cancel();
        thn.stopObserveDom(calendarContainer, refreshPage);
        refreshPage = null;
      });
    }
    const $ = window.jQuery;

    if (!$ || thn.fbStateChangeSimulator) {
      return;
    }

    // Fastbooking used to trigger an state change but
    // recently we detected they are not doing that anymore.
    // In order makes as few changes as possible,
    // we'll call the onStateChange function "manually"
    // when the "main" div seccions change (that is
    // the direct childs of #fb-main-container, and #fb-localize)

    thn.fbStateChangeSimulator = thn.debounce(thn.onStateChange, 800);

    $('#fb-main-container > [id^=fb-], #fb-localize').each(function (idx, el) {
      thn.observeDom(
        el,
        thn.fbStateChangeSimulator,
        {
          subtree: false,
          attributes: true,
        },
      );

      thn.pageUnload(function () {
        thn.stopObserveDom(el, thn.fbStateChangeSimulator);
      });
    });

    thn.pageUnload(function () {
      delete thn.fbStateChangeSimulator;
    });

    // For Hotel Nice Riviera
    const langContainer = document.documentElement;

    if (thn.data.propertyId === 1013812 && langContainer) {
      const refreshLang = thn.debounce(thn.languageCheck, 150);
      thn.observeDom(langContainer, refreshLang, {
        attributes: true,
      });
      thn.shutdown(() => {
        refreshLang.cancel();
        thn.stopObserveDom(langContainer, refreshLang);
      });
    }

    // Only for Jannah Resorts & Hotels
    if (thn.data.accountUserId === 1033072) {
      $(document).on('click', '[data-toggle=tab]', function () {
        thn.logger.debug('Boot listener triggered! Checking page..');
        setTimeout(thn.pageCheck, 200);
      });
    }

    // Detect if Calendar is visible in R&R
    const containerSearch = document.querySelector('#fb-quicksearch');
    if (containerSearch) {
      const pageCheckCalendar = thn.debounce(() => {
        const isCalendarVisible = thn.isVisible(document.querySelector('.daterangepicker, .quicksearch-panel.theme-quicksearch-panel'));
        if (isCalendarVisible) {
          thn.pageCheck();
        } else if (thn.widgets.price.isTargetPage('Rooms and Rates') && isLindenbergHotels) {
          thn.pageCheck({ force: true });
        }
      }, 400);

      thn.observeDom(containerSearch, pageCheckCalendar, {
        childList: true,
        subtree: true,
        attributes: true,
      });

      thn.shutdown(() => {
        pageCheckCalendar.cancel();
        thn.stopObserveDom(containerSearch, pageCheckCalendar);
      });
    }

  };

  engine.isUserLogged = function isUserLogged(ctx) {
    let isLogged = false;
    // Let's check if there is a user id in dataLayer
    if (window.dataLayer) {
      window.dataLayer.forEach(function (obj) {
        const dlKeys = Object.keys(obj);
        if (dlKeys.includes('user_id')) {
          isLogged = true;
        }
      });
      // Let's check if the second dataLayer exists if we have not yet detected that we are logged in
    } else if (window.dataLayerFB && !isLogged) {
      const loyalty = window.dataLayerFB.find(function (obj) {
        const elLoyalty = obj.loyalty;
        return !thn.empty(elLoyalty);
      });
      if (loyalty) {
        isLogged = true;
      }
    }

    // Last check with DOM elements

    if (document.querySelector('.fb-ghs-logged-in')) {
      isLogged = true;
    }

    return isLogged;
  };

  /**
     * @memberOf module:bs_53
     * @this thn.widgets.price
     * @see {@link Price#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceObserveDom = function priceObserveDom(ctx) {

    let resultElement;
    if (!ctx.widget.isSet() && !thn.fbObserver && thn.data.pageName === 'Rooms and Rates') {

      resultElement = document.querySelector('#fb-results');
      if (resultElement) {
        thn.fbObserver = thn.debounce(function () {
          ctx.widget.logger.debug('*************** DOM Changed **************');
          ctx.widget.setData();
          if (ctx.widget.isSet()) {
            ctx.widget.show();
            thn.stopObserveDom(resultElement, thn.fbObserver);
            delete thn.fbObserver;
          }
        }, 1600); // must be greatly delayed, because we get info from dataLayer (sloooow to update)
        thn.observeDom(resultElement, thn.fbObserver);

        thn.pageUnload(function () {
          thn.stopObserveDom(resultElement, thn.fbObserver);
          delete thn.fbObserver;
        });
      }
    }

    const breadcrumbs = document.querySelectorAll('*[id*=fb-header-breadcrumb-step-]');
    if (breadcrumbs.length > 0 && !thn.fbBreadcrumbObserver) {
      thn.fbBreadcrumbObserver = thn.debounce(function () {
        breadcrumbs.forEach(function (breadcrumb) {
          if (breadcrumb.classList.contains('active')) {
            thn.pageCheck();
          }
        });
      }, 400);

      breadcrumbs.forEach(function (breadcrumb) {
        thn.observeDom(breadcrumb, thn.fbBreadcrumbObserver, {
          attributes: true,
          attributeFilter: ['class'],
        });

        thn.pageUnload(function () {
          thn.stopObserveDom(breadcrumb, thn.fbBreadcrumbObserver);
        });
      });
    }

  };

  /**
     * @memberOf module:bs_53
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData = function priceParseData(ctx) {

    const widgetData = {};
    const $ = window.jQuery;

    const dataLayer = new thn.DataLayerHelper(window.dataLayerFB || {});
    const quicksearch = dataLayer.get('quicksearch');
    if (!quicksearch) {
      ctx.widget.logger.warn('Unable to "quicksearch" property in dataLayerFB');
    }

    function getRoomNumber() {
      if (document.querySelector('[data-key=results-choose-first-room]')) {
        return 1;
      }
      if (document.querySelector('[data-key=results-choose-second-room]')) {
        return 2;
      }
      if (document.querySelector('[data-key=results-choose-third-room]')) {
        return 3;
      }
      return 1;
    }

    function updateGuests(specificRoom) {

      let adults;
      let children;
      let roomInfo;
      let room = 1;
      let rooms = (document.getElementById('fb-qs-summary-rooms-quantity') && thn.parseNumber(document.getElementById('fb-qs-summary-rooms-quantity').textContent)) || 1;
      if (specificRoom !== undefined) {
        // When we want the guests an specific room
        // just target that room
        room = specificRoom;
        rooms = specificRoom;
      }
      widgetData.adults = 0;
      widgetData.children = 0;
      widgetData.roomsDispo = [];

      // Do not use quicksearch for these uids
      const noQuicksearch = [1032394, 1032909, 1032496, 1037109, 1032935];

      while (room <= rooms) {
        if (!quicksearch || !quicksearch.rooms || noQuicksearch.includes(thn.data.accountUserId)) {
          if (thn.parseUrlParameter(`adults${room}`)) {
            widgetData.adults = parseInt(thn.parseUrlParameter(`adults${room}`), 10) || 2;
            widgetData.children = parseInt(thn.parseUrlParameter(`children${room}`), 10) || 0;
          } else {
            widgetData.adults = 2;
          }

          widgetData.guests = widgetData.adults + widgetData.children;
          roomInfo = {
            adults: widgetData.adults,
            children: widgetData.children,
            childrenAges: [],
          };

          if (widgetData.children && thn.parseUrlParameter(`childrenAges${room}`)) {
            roomInfo.childrenAges = thn.parseUrlParameter(`childrenAges${room}`).split(',').map((el) => parseInt(el, 10) || 10) || [];
          }
        } else {
          adults = quicksearch.adults[`adults${room}`];
          widgetData.adults += adults;
          children = quicksearch.children[`children${room}`];
          widgetData.children += children;
          roomInfo = undefined;

          // build the detailed room information
          roomInfo = {
            adults,
            children,
            childrenAges: [],
          };

          // If children detected, add children ages
          if (children) {
            if (!thn.empty(quicksearch.childrenAges)) {
              roomInfo.childrenAges = quicksearch.childrenAges[`childrenAges${room}`].map((age) => age || 10); // copy
            }
          }
        }
        widgetData.roomsDispo.push(roomInfo);
        room += 1;
      }

      widgetData.guests = Math.max(1, widgetData.adults + widgetData.children);

    } // update_guests

    let priceCurrency;

    // If loading OR not jQuery: exit
    if (!$ || Array.from(document.getElementsByClassName('fb-loading')).filter(thn.isVisible).length) {
      return widgetData;

    }

    // Basket empty - Exit PW because when a room is in the basket, the BE doesn't always list all the rooms
    const packages = (window.$fb && window.$fb.basket && window.$fb.basket._state && window.$fb.basket._state.data && window.$fb.basket._state.data.packages);
    if (packages && Array.isArray(packages) && packages.length && !isLindenbergHotels) {
      this.logger.warn('The basket is not empty: avoid PW comparison');
      // Do not execute PW at all
      return widgetData;
    }

    const promoCode = window.location.search.match(/\bcode=[^&]+/)
      // users in this list will show PW even with promo_code
      && ![
        // Innotel
        1032574, 1033982,
        // Airport-hotels
        1032496,
        // Ayodya Resort Bali
        1034362,
        // Manotel
        1032506,
        // Hotel Delfino
        1035089,
      ].includes(thn.data.accountUserId);

    let specificRate = false;
    if (![1033417, 1033982].includes(thn.data.accountUserId)) {
      // Example: ...&rate=HALF-BOARD...
      specificRate = window.location.search.match(/rate=[^&]+/);
    }

    const $arrival = $('#fb-qs-arrival, #fb-qs-summary-dates-arrival').find('.fb-date');
    const $departure = $('#fb-qs-departure, #fb-qs-summary-dates-departure').find('.fb-date');
    widgetData.dateBegin = $arrival.length && $arrival.data('date').replace(/-/g, '/');
    widgetData.dateEnd = $departure.length && $departure.data('date').replace(/-/g, '/');

    // Include the language to detect to trigger a refresh
    widgetData.language = thn.data.language;

    const roomNow = getRoomNumber();
    const currentRoom = isLindenbergHotels ? roomNow : $('[data-key=results-rate-choose-room-nb]:eq(0)').data('placeholders') || 1;
    widgetData.rooms = 1;
    updateGuests(currentRoom);

    // initialize currency from the selector
    const parts = $('#fb-cur-lang').text().trim().match(/[A-Z]{3}/);
    if (parts && parts.length > 0) {
      widgetData.currency = parts[0];
    }

    if (document.querySelector('[data-key=search-no-availability]')) {
      widgetData.rooms = thn.parseNumber(document.querySelector('#fb-qs-summary-rooms-quantity')?.textContent);
      updateGuests(); // no params to get *all* guests
      widgetData.noRooms = true;
      return widgetData;
    }

    if ($('#results-items').find('.fb-error').length === 0 && document.querySelector('.fbw-calendar')) {

      widgetData.price = undefined;
      $.each($('#results-items').find('.fb-results-price .fb-price-amount > .fb-price:not(.campaign-price-barred)'), function (index, value) {
        const text = $(value).clone().children('.fb-price').remove()
          .end()
          .text();
        const price = thn.parseNumber(text);
        const currency = (text.match(/[^\d\s,.]+/) || [])[0];
        if (widgetData.price === undefined || price < widgetData.price) {
          widgetData.price = price;
        }
        if (!priceCurrency && currency !== '$') { // do not trust $ symbol never ever
          priceCurrency = thn.getCurrencyCode(currency);
        }
      });
      if (widgetData.price === undefined || !thn.isNumeric(widgetData.price)) {
        // Another case where Fastbooking has another clases for prices.
        // It's important to parse two prices below 'fb-results-rate--right', on the other element 'fb-results-rate--left'
        // We have a .fb-price element  with the money the discount is subtracting
        // Also, avoid to parse striket-through prices
        const $prices = $('#results-items .fb-results-rate--right .fb-price:not(.barred-price)');
        const prices = $prices.map(function (key, e) {
          let priceInstance = `${$(e).find('.fb-price-integer').text()}.${$(e).find('.fb-price-decimal').text()}`;
          if (priceInstance === '.') {
            // This price has no offer and no splitted interger and decimal parts.
            priceInstance = $(e).eq(0).text();
          }
          // price_instance text includes currency symbol/code, and it's needed in order to handle special currencies with 3 decimals.

          if (widgetData.currency === 'IDR') {
            return thn.parseNumber(priceInstance, { allowThreeDecimals: false });
          }
          return thn.parseNumber(priceInstance);
        }).toArray();
        widgetData.price = Math.min(...prices);
      }
      if (widgetData.price !== undefined) {
        widgetData.price /= thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
      }

      if (priceCurrency) { // prefer currency from the price
        widgetData.currency = priceCurrency;
      }

      if (thn.isIframed()) {
        // preventively remove the review widget
        window.parent.postMessage({
          action: 'remove_review_widget',
        }, document.referrer);
      }

      // ROOM DETAILS
      // widgetData.roomDetails = engine.room_details_parse_data(widgetData);

      widgetData.priceSpecial = (specificRate || promoCode) ? 1 : 0;
      widgetData.set = true;

    }
    // price
    const arrival = thn.parseUrlParameter('arrival')?.replace(/-/g, '/');
    const departure = thn.parseUrlParameter('departure')?.replace(/-/g, '/');
    const nights = thn.daysBetween(arrival, departure);

    const roomPrices = [...document.querySelectorAll('.new-price')];

    if (roomPrices.length > 0) {
      const pricesArr = roomPrices.map((price) => thn.parseNumber(price.textContent))?.filter(Boolean);
      const isPricePerNight = !!document.querySelector('.fb-price-small-text .fb-translate[data-key="night"]');
      widgetData.price = isPricePerNight ? Math.min(...pricesArr) / nights : Math.min(...pricesArr);
    }

    // Room Details Function Here
    widgetData.roomDetails = engine._roomDetailsParseData();

    return widgetData;
  };

  /**
     *
     * @memberOf module:bs_53
     *
     */
  engine._roomDetailsParseData = function _roomDetailsParseData() {
    const roomDetailsArray = [];
    const dataLayer = new thn.DataLayerHelper(window.dataLayerFB || {});
    const quicksearch = dataLayer.get('quicksearch');
    // Dates - We need to get the dates because the price of each room is the total and we need to divide it by night.
    let dateBegin = quicksearch && quicksearch.arrival ? quicksearch.arrival : document.querySelector('[id*="summary-dates-arrival"] .fb-date').getAttribute('data-date') || '';
    let dateEnd = quicksearch && quicksearch.departure ? quicksearch.departure : document.querySelector('[id*="summary-dates-departure"] .fb-date').getAttribute('data-date') || '';
    let nights;
    if (dateBegin && dateEnd) {
      dateBegin = dateBegin.replace(/-/g, '/');
      dateEnd = dateEnd.replace(/-/g, '/');
      nights = thn.daysBetween(dateBegin, dateEnd);
    }

    const roomAdults = thn.parseNumber((document.querySelector('[id *= "summary-rooms-adults"]') || {}).textContent) || 2;
    const roomChildren = thn.parseNumber((document.querySelector('[id *= "summary-rooms-children"]') || {}).textContent) || 0;

    // Rooms
    const roomSelector = document.querySelectorAll('[class *= "results-accommodation"]');
    if (roomSelector) {
      roomSelector.forEach(function (element) {
        const typeRoomSelector = {
          Junior: 'junior suite',
          Suite: 'suite',
          Triple: 'triple',
          Family: 'family room',
          Privilege: 'privilege',
          Tradition: 'tradition',
        };
        const roomName = element.querySelector('.fb-results-acc-title span') && (element.querySelector('.fb-results-acc-title span').getAttribute('data-fallback') || '').replace(/-/g, ' ');
        const roomType = (Object.keys(typeRoomSelector).filter((key) => ((roomName)).toLowerCase().includes(typeRoomSelector[key]))[0] || 'Standard');
        const roomId = element.getAttribute('id') || '';

        const pricesInfo = element.querySelectorAll('.fb-results-rate');
        const roomData = {
          id: roomId,
          name: roomName,
          adults: roomAdults,
          children: roomChildren,
          prices: [],
        };
        roomData.type = roomType;
        if (pricesInfo) {
          pricesInfo.forEach(function (priceUnit) {
            const priceItemName = (priceUnit.querySelector('.fb-results-rate-title') || {}).textContent || '';
            const priceId = priceUnit.getAttribute('id') || '';
            const price = priceUnit.querySelector('.new-price') ? priceUnit.querySelector('.new-price').textContent : (priceUnit.querySelector('.fb-price') || {}).textContent || '';
            const priceData = {
              id: priceId,
              name: priceItemName,
              totalNight: price && nights ? thn.parseNumber(price) / nights : '',
              breakfast: priceUnit.querySelector('[data-key*="meal-type-breakfast"]') ? 1 : 0,
              refundable: priceUnit.querySelector('[data-key*="not-amendable"]') ? 0 : 1,
            };
            roomData.prices.push(priceData);
          });
          roomDetailsArray.push(roomData);
        }
        return roomData;
      });
    }
    return roomDetailsArray;
  };

  /**
     * @memberOf module:bs_53
     * @this thn.widgets.booking
     * @see {@link Booking#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingObserveDom = function bookingObserveDom(ctx) {

    if (!ctx.widget.isSet()) {

      const el = document.getElementById('fb-main-container')
        || document.getElementsByTagName('body')[0];

      const thnObserveDomFunction = function thnObserveDomFunction() {
        ctx.widget.logger.debug('*************** DOM Changed **************');
        if (ctx.widget.setData().isSet()) {
          ctx.widget.save();
          thn.stopObserveDom(el, thnObserveDomFunction);
        }
      };

      thn.observeDom(el, thnObserveDomFunction);

      thn.pageUnload(function () {
        thn.stopObserveDom(el, thnObserveDomFunction);
      });
    }
  };

  /**
     * @memberOf module:bs_53
     * @this thn.widgets.booking
     * @see {@link Booking#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingParseData = function bookingParseData(ctx) {

    const widgetData = {};

    // If loading ....
    if (Array.from(document.getElementsByClassName('fb-loading')).filter(thn.isVisible).length) {

      widgetData.set = false;

      // If NOT a cancellation
    } else if (!document.getElementsByClassName('fb-confirm-cancel').length) {

      const booking = window.dataLayerFB && thn.arrayGet(window.dataLayerFB, 'booking');

      if (booking) { // preferred

        widgetData.bookingId = booking.confirmation;
        widgetData.price = booking.totalPrice;
        widgetData.currency = booking.currency;
        widgetData.dateBegin = booking.checkin.replace(/-/g, '/');
        widgetData.dateEnd = booking.checkout.replace(/-/g, '/');
        widgetData.promocode = thn.parseUrlParameter('code');

      }

      if (!widgetData.price) { // legacy

        widgetData.price = 0;
        Array.from(document.getElementsByClassName('fb-price')).forEach(function (el) {
          const price = parseFloat(el.getAttribute('data-price')) || 0;
          if (price > widgetData.price) {
            widgetData.price = price;
            widgetData.currency = el.getAttribute('data-origincurrency');
            if (!widgetData.currency) {
              const guess = el.textContent.match(/[^\s\d,.]+/);
              if (guess && guess.length) {
                widgetData.currency = thn.getCurrencyCode(guess[0]);
              }
            }
          }
        });
      }

      if (!widgetData.bookingId) {
        const bookingEls = document.getElementsByClassName('fb-confirm-title');
        if (bookingEls.length) {
          // first option
          const bookingElCopy = bookingEls[0].cloneNode(true);
          Array.from(bookingElCopy.children).forEach(function (child) { child.remove(); });
          widgetData.bookingId = bookingElCopy.textContent.trim();
          // second option
          if (!widgetData.bookingId && bookingEls[0].childNodes.length === 2) {
            widgetData.bookingId = bookingEls[0].childNodes[1].nodeValue.trim();
          }
        }
      }

      if (!widgetData.dateBegin
        || !widgetData.dateEnd) {
        try {
          let dates = Array.from(document.getElementsByTagName('span')).filter(function (el) {
            return el.getAttribute('data-key') === 'date-from-to';
          });
          if (dates.length) {
            dates = decodeURIComponent(unescape(dates[0].getAttribute('data-placeholders')))
              .split('|')
              .map(function (date) {
                return date.match(/\d+\D+\d+/)[0];
              });
            widgetData.dateBegin = translateDate(dates[0], thn.data.language);
            widgetData.dateEnd = translateDate(dates[1], thn.data.language);
          }
        } catch (err) {
          thn.logger.debug(err, '--- Error Getting Dates ---');
        }
      }

      // if no bookingId, then wait ...
      if (!widgetData.bookingId) {
        widgetData.set = false;
      }

    } // If not a cancellation

    return widgetData;
  };

  /**
   * @memberOf module:bs_53
   * @this thn.widgets.price
   * @see {@link Price#get_promocode}
   *
   * @param {object} ctx - The context object.
   */
  engine.getPromocode = function getPromocode(ctx) {
    const promoCode = thn.parseUrlParameter('code');

    if (promoCode) {
      ctx.promocode = promoCode;
    }
    return ctx.promocode;
  };

  return engine;
}

export { factory };
